import React, { ReactElement } from "react";
import FadeLoader from "react-spinners/FadeLoader";
import OpenColor from "open-color";

export default function GlobalSpinner({ isView }: { isView: boolean }): ReactElement {
  return (
    <div
      style={{
        position: "absolute",
        top: "0",
        left: "0",
        zIndex: "100",
        backgroundColor: "#fff",
        opacity: "0.5",
        height: "100%",
        width: "100%",
        display: isView ? "block" : "none",
      }}
    >
      <div
        style={{
          display: isView ? "flex" : "none",
          position: "absolute",
          top: 0,
          left: 0,
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "100%",
          opacity: 0.5,
          zIndex: 150,
        }}
      >
        <FadeLoader color={OpenColor.gray[6]} loading={true} />
      </div>
    </div>
  );
}
